import { useMemo } from 'react';
import { I18nConfig, I18nTranslations } from '../types';

/**
 * Traduções padrão em inglês
 */
const defaultTranslations: I18nTranslations = {
  title: 'Chat',
  subtitle: 'How can we help you?',
  footer: '',
  getStarted: 'Start Chat',
  inputPlaceholder: 'Type your message...',
  initialMessages: [],
};

/**
 * Hook para gerenciar internacionalização
 *
 * @param i18n - Configuração de traduções
 * @param defaultLanguage - Idioma padrão
 * @returns Traduções para o idioma selecionado
 */
export const useI18n = (
  i18n: I18nConfig,
  defaultLanguage: string = 'en'
): I18nTranslations => {
  const i18nKey = useMemo(() => JSON.stringify(i18n), [i18n]);

  return useMemo(() => {
    const languageTranslations = i18n[defaultLanguage] || i18n['en'] || defaultTranslations;
    return {
      ...defaultTranslations,
      ...languageTranslations,
    };
  }, [i18nKey, defaultLanguage]);
};
